import { Brand, BrandType } from '@nsw-paginas-deslogadas/constants'
import { removeAccents } from './format'

export const formatBrandParam = (brand: string): string => {
    brand = removeAccents(brand).replace(new RegExp('[- _]', 'gi'), '').toLocaleLowerCase()
    return brand
}

export const getBrandFromParam = (param: string): BrandType | null => {
    param = formatBrandParam(param)
    const brand = Object.values(Brand).find(brandProps => brandProps.params.includes(param))
    return brand || null
}

export const handleBrandSlug = (brandName: string): string => {
    if (brandName === 'Nav Dasa') {
        return 'Nav'
    }

    return brandName
}
